/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */

import React, {useEffect, useState} from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AuthService from "../service/auth.service";

const authSVC = new AuthService()
const PrivateRoute = ({...rest}) => {
    const [loggedIn, setLoggedIn] = useState(authSVC.hasToken())
    useEffect(()=>{
        setLoggedIn(authSVC.hasToken())
    })

    return (
        loggedIn ? (<Route {...rest}  />) : (
            <Route {...rest} render={props => (
                <Redirect to={{
                        pathname: "/login",
                        state: {from: props.location},
                    }} />
            )} />
        )
    );
};

export {PrivateRoute};
